import React, { useEffect, useState } from "react";
import cs from "classnames";
import "./welcomeFormStep.scss";
import LineSelect from "../../UI/LineSelect";
import CustomInput from "../../UI/CustomInput";
import SelectPlatform from "./SelectPlatform";
import { useDispatch, useSelector } from "react-redux";
import { setStepsData } from "../../../redux/actions/OnboardingAction";
import { onboardingStepsSelector } from "../../../redux/selectors/OnboardingSelectors.ts";
import Form from "react-bootstrap/Form";

const WelcomeFormStep = ({ step, addGoal, setAddGoal,setAddPainpoint,addpainPoint }) => {
  
  const initialGoal = [
    {
      title: "Improve organization",
      isSelect: false,
      id: 1,
    },
    {
      title: "Save time",
      isSelect: false,
      id: 2,
    },
    {
      title: "Understand the value of my time and labor",
      isSelect: false,
      id: 3,
    },
    {
      title: "Price products more effectively",
      isSelect: false,
      id: 4,
    },
    {
      title: "Streamline and manage multiple income streams",
      isSelect: false,
      id: 5,
    },
    {
      title: "Optimize profits",
      isSelect: false,
      id: 6,
    },
  ];
  const initialPainpoint = [
    {
      title: "Pricing and repricing ",
      isSelect: false,
      id: 1,
    },
    {
      title: "Managing and tracking sales, expenses, profits ",
      isSelect: false,
      id: 2,
    },
    {
      title: "Profit analysis ",
      isSelect: false,
      id: 3,
    },
    {
      title: "Procuring products and inventory ",
      isSelect: false,
      id: 4,
    },
   
  ];
  const initialProfit = [
    {
      title: "Under $500",
      isSelect: false,
      id: 1,
    },
    {
      title: "$500-$2500",
      isSelect: false,
      id: 2,
    },
    {
      title: "$2500-$7500",
      isSelect: false,
      id: 3,
    },
    {
      title: "$7500-$10,000",
      isSelect: false,
      id: 4,
    },
    {
      title: "$10,000+",
      isSelect: false,
      id: 5,
    },
  ];
  const initialBusinessType = [
    {
      title: "Seller",
      isSelect: false,
      id: 1,
    },
    {
      title: "Reseller",
      isSelect: false,
      id: 2,
    },
  ];

  const initialFeatureType = [
    {
      title: "Pricing Discovery Calculators ",
      isSelect: false,
      id: 1,
    },
    {
      title: "Profit Analysis ",
      isSelect: false,
      id: 2,
    },
    {
      title: "Expense Tracking ",
      isSelect: false,
      id: 3,
    },
    {
      title: "Sales Forecasting ",
      isSelect: false,
      id: 4,
    },
  ];

  const [profit, setProfit] = useState(initialProfit);
  const dispatch = useDispatch();
  const [goal, setGoal] = useState(initialGoal);
  const [painpoint, setPainpoint] = useState(initialPainpoint);
  const [businessType, setBusinessType] = useState(initialBusinessType);
  const [platform, setPlatform] = useState<any>([]);
  const [platformOtherVal, setPlatformOtherVal] = useState<string>("");
  const [goalInputError, setGoalInputError] = useState(false);
  const [featureType, setFeatureType] = useState(initialFeatureType);

  const steps = useSelector(onboardingStepsSelector);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPlatform(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value,
    );
  };

  const handleAddGoal = (event) => {
    const {
      target: { value },
    } = event;
    setAddGoal(value);
    setGoalInputError(!value);
  };

  const handleAddpainpoint = (event) => {
    const {
      target: { value },
    } = event;
    setAddPainpoint(value);
    setGoalInputError(!value);
  };

  const getSelectTypeData = (value, array) => {
    return array.map((data) =>
      value.includes(data.title) ? { ...data, isSelect: true } : { ...data },
    );
  };

  useEffect(() => {
    if (steps.platforms) {
      setPlatform(steps.platforms);
    }
    if (steps.sellerType) {
      setBusinessType(getSelectTypeData(steps.sellerType, initialBusinessType));
    }

    if (steps.profit) {
      setProfit(getSelectTypeData(steps.profit, initialProfit));
    }
    if (steps.goal) {
      setGoal(getSelectTypeData(steps.goal, initialGoal));
    }
    if (steps.feature) {
      setFeatureType(getSelectTypeData(steps.feature, initialFeatureType));
    }
  }, []);

  useEffect(() => {
    const platformData = platform.map((d) =>
      d === "Custom" ? platformOtherVal : d,
    );
    dispatch(setStepsData({ platforms: platformData }));
  }, [platform, platformOtherVal]);

  useEffect(() => {
    if (businessType) {
      const sellerType = businessType
        ?.filter((data) => data.isSelect)
        ?.map((d) => d.title);
      dispatch(setStepsData({ sellerType }));
    }
  }, [businessType]);

  useEffect(() => {
    if (profit) {
      const profitAvg = profit?.find((data) => data.isSelect)?.title;
      dispatch(setStepsData({ profit: profitAvg }));
    }
  }, [profit]);

  useEffect(() => {
    if (goal) {
      const goalValArray = goal?.filter((data) => data.isSelect);
      const goalValues = goalValArray?.map((data) => data.title);
      addGoal !== "" && goalValues.push(addGoal);
      dispatch(setStepsData({ goal: goalValues }));
    }
  }, [goal, addGoal]);

  useEffect(() => {
    if (featureType) {
      const featureValArray = featureType?.filter((data) => data.isSelect);
      const featureValues = featureValArray?.map((data) => data.title);
      dispatch(setStepsData({ feature: featureValues }));
    }
  }, [featureType]);

  const renderForm = () => {
    switch (step) {
      case 2:
        return (
          <div className="step-space">
            <div className="title-space">
              <h3 className="section-title text-center">
                What platform do you sell through?
              </h3>
              <div className="selectPlatform">
                <SelectPlatform
                  label="Select Platform"
                  value={platform}
                  onChange={handleChange}
                  options={[
                    "Etsy",
                    "Poshmark",
                    "Depop",
                    "Shopify",
                    "StockX",
                    "GOAT",
                    "eBay",
                    "Amazon",
                    "Instagram",
                    "Facebook Marketplace",
                    "Grailed",
                    "Mercari",
                    "My own website",
                    "Alias",
                    "Vinted",
                    "OfferUp",
                    "Custom",
                  ]}
                  setPlatform={setPlatform}
                />
              </div>
              {platform.includes("Custom") && (
                <CustomInput
                  formControlClass="border-input max-width-input"
                  placeholder="Type answer here.."
                  value={platformOtherVal}
                  onChange={({ target: { value } }) =>
                    setPlatformOtherVal(value)
                  }
                />
              )}
            </div>
          </div>
        );
      case 3:
        return (
          <div className="select-options-space">
            <div className="title-space mb-5">
              <h3 className="section-title text-center">
                Are you a seller or reseller?
              </h3>
              <div className="lineSelectPlatform">
                <div>
                  {businessType.map((data) => (
                    <LineSelect
                      title={data.title}
                      active={data.isSelect}
                      id={data.id}
                      list={businessType}
                      setList={setBusinessType}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        );
      case 4:
        return (
          <div className="select-options-space">
            <div className="title-space mb-5">
              <h3 className="section-title text-center">
                On average, how much profit do you estimate you earn a month?
              </h3>
              <div className="lineSelectPlatform">
                <div>
                  {profit.map((data) => (
                    <LineSelect
                      title={data.title}
                      active={data.isSelect}
                      id={data.id}
                      list={profit}
                      setList={setProfit}
                      isOneSelect
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        );
      case 5:
        return (
          <div className="select-options-space">
            <div className="title-space mb-5">
              <h3 className="section-title text-center">
                What is your main goal in using Sotira?
              </h3>
              <p className="site-description">
                {/*You may select multiple options.*/}
              </p>
              <div className="lineSelectPlatform d-flex flex-column">
                <div style={{ margin: "0 0 20px" }}>
                  <Form.Label style={{ fontSize: 16 }} className="required">
                    Type your goal
                  </Form.Label>
                  <Form.Group>
                    <Form.Control
                      className={cs("goal-input", {
                        ["active-input"]: addGoal,
                        ["error-input"]: goalInputError,
                      })}
                      autoFocus
                      type="text"
                      placeholder="Add Your Goal"
                      value={addGoal}
                      onChange={handleAddGoal}
                    />
                  </Form.Group>
                </div>
                <div className="w-100">
                  <Form.Label style={{ fontSize: 16 }}>
                    Select options. You may choose multiple.
                  </Form.Label>
                  {goal.map((data) => (
                    <LineSelect
                      title={data.title}
                      active={data.isSelect}
                      id={data.id}
                      list={goal}
                      setList={setGoal}
                      size="full"
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        );
        case 6:
        return (
          <div className="select-options-space">
            <div className="title-space mb-5">
              <h3 className="section-title text-center">
              What is your biggest pain point in running your business?
              </h3>
              <p className="site-description">
                {/*You may select multiple options.*/}
              </p>
              <div className="lineSelectPlatform d-flex flex-column">
                <div style={{ margin: "0 0 20px" }}>
                  <Form.Label style={{ fontSize: 16 }} >
                    Type your pain point
                  </Form.Label>
                  <Form.Group>
                    <Form.Control
                      className={cs("goal-input", {
                        ["active-input"]: addpainPoint,
                        ["error-input"]: goalInputError,
                      })}
                      autoFocus
                      type="text"
                      placeholder="Add Your Pain Point"
                      value={addpainPoint}
                      onChange={handleAddpainpoint}
                    />
                  </Form.Group>
                </div>
                <div className="w-100">
                  <Form.Label style={{ fontSize: 16 }}>
                    Select option. You may choose only one.
                  </Form.Label>
                  {painpoint.map((data) => (
                    <LineSelect
                      title={data.title}
                      active={data.isSelect}
                      id={data.id}
                      list={painpoint}
                      setList={setPainpoint}
                      size="full"
                      isOneSelect

                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        );
      default:
        return <div />;
    }
  };
  return (
    <div>
      <div className="line-wrapper">
        {[2, 3, 4, 5, 6,7].map((data) => (
          <div className={cs("stepsLine", { ["active"]: data <= step })} />
        ))}
      </div>

      {renderForm()}
    </div>
  );
};
export default WelcomeFormStep;
